import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  TrackByFunction,
} from '@angular/core';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TranslatePipe } from '@recruitee/i18n';
import {
  DialogData,
  DialogRef,
  DividerComponent,
  BoxComponent,
  ButtonComponent,
} from '@recruitee/user-interface';

import { AsyncJobViewModel } from '../../async-job-view.types';
import { AsyncJobsProgressDisplayComponent } from '../async-jobs-progress-display/async-jobs-progress-display.component';

@Component({
  selector: 'rt-async-jobs-dialog',
  templateUrl: './async-jobs-dialog.component.html',
  styleUrls: ['./async-jobs-dialog.component.less'],
  standalone: true,
  imports: [
    BoxComponent,
    AsyncJobsProgressDisplayComponent,
    DividerComponent,
    ButtonComponent,
    TranslatePipe,
  ],
})
export class AsyncJobsDialogComponent implements OnInit, OnDestroy {
  public jobs: AsyncJobViewModel[] = [];
  public allCompleted: boolean = false;

  private ngOnDestroy$ = new Subject<void>();

  constructor(
    public dialogRef: DialogRef,
    @Inject(DialogData) public jobsDisplayStream$: Observable<AsyncJobViewModel[]>,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.jobsDisplayStream$.pipe(takeUntil(this.ngOnDestroy$.asObservable())).subscribe(jobs => {
      this.jobs = jobs;
      this.cdRef.detectChanges();
    });
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public trackByAsyncJob<T extends AsyncJobViewModel>(index: number, job: T): string {
    return job.uuid;
  }

  public trackByError: TrackByFunction<string> = (index: number, error: string): string => error;
}
